import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleRight } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';

import Banner from 'components/banner';

export function MoveRecordsConfirmation({ sourceDatabase, targetDatabase, selectedPropertyIds }) {
  const count = selectedPropertyIds.length;

  const infoMessage = () => {
    return (
      <React.Fragment>
        <h3 className="bold mb-4">Move Properties</h3>
        <div className="d-flex mb-2">
          <div className="align-self-center">
            <FontAwesomeIcon className="double-chevron text-primary mr-3" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div className='"align-self-center'>
            <strong>Property (Moved to Selected Database; Deleted from Current Database)</strong>
            <br />
            Property Information, Location Information, Building, Land, Multifamily Information and Media
          </div>
        </div>
        <div className="d-flex mb-2">
          <div className="align-self-center">
            <FontAwesomeIcon className="double-chevron text-primary mr-3" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div className="align-self-center">
            <strong>Related Data (Copied to Selected Database; Remains from Current Database)</strong>
            <br />
            Activities and Tasks, Groups, Tags, Related Contacts, Sale and Lease Comps and Listings
          </div>
        </div>
      </React.Fragment>
    );
  };

  const firstDescription = () => {
    return (
      <div className="align-self-center px-4">
        Once moved to {targetDatabase.name}, this properties will be&nbsp;
        <strong>deleted</strong> from {sourceDatabase.name}.
      </div>
    );
  };  

  const secondDescription = () => {
    return (
      <div className="align-self-center px-4">
        <strong>All related data will be copied</strong> to my {targetDatabase.name} and therefore&nbsp;
        <strong>exist in both</strong> {sourceDatabase.name} and {targetDatabase.name}
      </div>
    );
  };

  return (
    <React.Fragment>
      <p>
        {
          `${count} ${pluralize('property', count)} will be moved `
          + `from ${sourceDatabase.name} to ${targetDatabase.name}.`
        }
      </p>
      <Banner
        bannerIconType="danger"
        bannerStyle="danger"
        content={firstDescription()}
        infoMessage={infoMessage()}
      />
      <Banner
        content={secondDescription()}
        infoMessage={infoMessage()}
      />
      <p>You will receive an email when the move is complete.</p>
    </React.Fragment>
  );
}

MoveRecordsConfirmation.propTypes = {
  selectedPropertyIds: PropTypes.array.isRequired,
  sourceDatabase: PropTypes.object.isRequired,
  targetDatabase: PropTypes.object.isRequired
};


const mapStateToProps = state => ({
  selectedPropertyIds: state.selectList.selectedPropertyIds,
});

export default connect(mapStateToProps, null)(MoveRecordsConfirmation);
